import React from 'react';
import { FormProvider, useForm } from 'react-hook-form/dist/index.ie11';
import { EmployeeFormFields } from 'src/components/enterprise/features/Employee/components/Form/types/EmployeeForm';

export type EmployeeFormWrapperProps = {
  children: React.ReactNode;
  defaultValues?: EmployeeFormFields;
};

export const EmployeeFormWrapper: React.FC<EmployeeFormWrapperProps> = ({
  children,
  defaultValues,
}) => {
  const methods = useForm<EmployeeFormFields>({
    mode: 'all',
    defaultValues,
  });

  return (
    <FormProvider {...methods}>
      <form>{children}</form>
    </FormProvider>
  );
};
